import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux'
import { setupStore } from './redux/store';

const store = setupStore();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>

);
